module.exports = __webpack_public_path__ + "static/media/4.2a4ed6d5.webp";